import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Stack,
  Alert,
  Stepper,
  Step,
  StepLabel,
  Paper,
  Divider,
  Card,
    TextField,
  CardContent,
  Chip,
  InputAdornment
} from '@mui/material';
import {
  Add,
  Folder,
  Description,
  Edit,
  WarningAmber
} from '@mui/icons-material';

import fascicoloApi from '../../api/fascicoloApi';
import documentoApi from '../../api/documentoApi';
import logprocessoApi from '../../api/logprocessoApi';

import DocumentoFascicoloTable from '../../components/DocumentoFascicoloTable';
import RichiesteDocumentoNonEvaseTable from '../../components/RichiesteDocumentoNonEvaseTable';

import { AuthContext } from '../../auth/AuthContext';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import FascicoloChat from '../../components/FascicoloChat';
import { formatDate } from '../../utils/dateFormatter';


export default function FascicoloDetailPageDesktop() {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const pageSize = 10000;

  const [previewUrl, setPreviewUrl] = useState(null);
  const [contribuente, setContribuente] = useState({});
  const [documenti, setDocumenti] = useState([]);
  const [richiesteNonEvase, setRichiesteNonEvase] = useState([]);
  const [fascicoloId, setFascicoloId] = useState(null);

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [sortField, setSortField] = useState('dataUpload');
  const [sortDirection, setSortDirection] = useState('DESC');

  const [jobLogs, setJobLogs] = useState([]);
  const [jobDocsState, setJobDocsState] = useState({});
  const [refreshDocumentiKey, setRefreshDocumentiKey] = useState(0);
  /* ========================= FETCH ========================= */

  useEffect(() => {
    const fetchFascicolo = async () => {
      try {
        const res = id
          ? await fascicoloApi.getFascicoloByContribuenteId(id)
          : await fascicoloApi.getMyFascicolo();

        setFascicoloId(res.data.id);
        setContribuente(res.data.contribuente);
        console.log("contribuente id",res.data.contribuente.id)
        fetchDocumentiFascicolo(res.data.id, 0);
        fetchRichiesteNonEvase(res.data.id);
        fetchJobLogs(res.data.id);
      } catch (err) {
        console.error(err);
      }
    };

    const refreshDocumenti = () => {
      setRefreshDocumentiKey(prev => prev + 1);
    };

    const fetchRichiesteNonEvase = async (fid) => {
      try {
        const res = await fascicoloApi.getRichiesteNonEvase(fid);
        setRichiesteNonEvase(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchFascicolo();
  }, [id, sortField, sortDirection]);

  const fetchDocumentiFascicolo = async (fid, page) => {
    try {
      const params = {
        page,
        size: 10000,
        sort: `${sortField},${sortDirection}`
      };

      const res = await fascicoloApi.getDocumentiFascicoloPaginated(fid, params);

      setDocumenti(res.data.content || []);
      setTotalPages(res.data.totalPages || 0);
      setPage(res.data.number || 0);
    } catch (err) {
      console.error(err);
    }
  };

const fetchJobLogs = async (fid) => {
  try {
    const res = await logprocessoApi.getByFascicolo(fid);

    const logsWithAnomalies = res.data.filter(
      l => l.anomalie && l.anomalie !== "{}"
    );

    setJobLogs(logsWithAnomalies);

    const initialState = {};

    logsWithAnomalies.forEach((job, jobIndex) => {

      let docs = {};
      let anomalieMap = {};

      try {
        docs = JSON.parse(job.testoplain || "{}");
      } catch {
        docs = {};
      }

      try {
        anomalieMap = JSON.parse(job.anomalie || "{}");
        console.log("anomaliemap",anomalieMap);
      } catch {
        anomalieMap = {};
        console.log("anomaliemap",anomalieMap);
      }

      initialState[jobIndex] = {};

      Object.entries(docs).forEach(([docKey, docStr]) => {

        // 👉 filtro: se NON esiste nell'anomalie → SKIP
        if (!anomalieMap[docKey]) {
          return;
        }

        let doc = {};
        try {
          doc = JSON.parse(docStr);
        } catch {
          doc = {};
        }

        let anomalie = [];
        try {
          anomalie = JSON.parse(anomalieMap[docKey]);
          console.log("docKey",docKey);
          console.log("anomalie",anomalie);
        } catch {
          anomalie = [];
        }

        initialState[jobIndex][docKey] = {
          documento: doc || {},
          scadenze: doc.scadenze || [],
          anomalie: anomalie.anomalie
        };
      });

    });
    console.log("initialState",initialState);
    setJobDocsState(initialState);

  } catch (err) {
    console.error(err);
  }
};

  /* ========================= AZIONI ========================= */

  const handleNuovoDocumento = () => {
    if (!fascicoloId) return;
    navigate(`/fascicolo/${fascicoloId}/documento/create`);
  };

  const handleParseDocumento = (doc) => {
    if (!fascicoloId) return;
    navigate(`/fascicolo/${fascicoloId}/documento/create`, {
      state: { documentoFascicoloId: doc.id }
    });
  };

  const handleDownload = async (documentoId) => {
    try {
      const response = await fascicoloApi.downloadDocumento(documentoId);

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' })
      );

      window.open(url, '_blank');
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (documentoId) => {
    try {
      await fascicoloApi.deleteDocumento(documentoId);
      setDocumenti(documenti.filter(d => d.id !== documentoId));
    } catch (err) {
      console.error(err);
    }
  };

  const handleCambiaStatoRichiesta = async (richiestaId, stato) => {
    try {
      await fascicoloApi.changeStatoRichiesta(richiestaId, stato);
      const res = await fascicoloApi.getRichiesteNonEvase(fascicoloId);
      setRichiesteNonEvase(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreaDocumentoDaRichiesta = (richiestaId, tipo) => {
    if (!fascicoloId) return;
    navigate(`/fascicolo/${fascicoloId}/documento/create`, { state: { richiestaId, tipo } });
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortField(field);
      setSortDirection('ASC');
    }

    fetchDocumentiFascicolo(fascicoloId, page);
  };

  /* ========================= SCADENZE JOB ========================= */

  const handleChangeScadenza = (jobIndex, docKey, index, field, value) => {
    setJobDocsState(prev => {
      const updatedJob = { ...prev[jobIndex] };
      const updatedDoc = { ...updatedJob[docKey].documento };
      const updatedScadenze = [ ...updatedJob[docKey].scadenze ];
      updatedScadenze[index][field] = value;

      updatedDoc.scadenze = updatedScadenze;
      updatedJob[docKey].documento = updatedDoc;
      updatedJob[docKey].scadenze = updatedScadenze;

      return { ...prev, [jobIndex]: updatedJob };
    });
  };

  const handleConfirmSave = async (jobId, docKey, doc) => {
    try {
      const params = { docKey: `${docKey}` };
      await documentoApi.create(doc,docKey);
      await logprocessoApi.aggiorna(jobId,params);
    } catch (err) {
      console.error(err);
    } finally {
      fetchJobLogs(fascicoloId);
    }
  };

  /* ========================= UI ========================= */

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>

      <BackButtonDesktop />

      {/* HEADER */}
      <Card sx={{ mb: 3, borderRadius: 3 }}>
        <CardContent>
          <Stack direction="row" justifyContent="space-between" alignItems="center">

            <Box>
              <Typography variant="h5" fontWeight={700}>
                Fascicolo
              </Typography>

              <Typography variant="body1" color="text.secondary">
                {contribuente.nome} {contribuente.cognome}
              </Typography>
            </Box>

          </Stack>
        </CardContent>
      </Card>

      {/* RICHIESTE */}
      <Card sx={{ mb: 3, borderRadius: 3 }}>
        <CardContent>

          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Folder color="primary" />
              <Typography variant="h6">Richieste Documento</Typography>
            </Stack>

            <ProtectedAction user={user} roles={['ADMIN', 'STUDIO']} contractState={user.statoContratto}>
              <Button
                variant="outlined"
                onClick={() => navigate(`/fascicolo/${fascicoloId}/richieste/create`)}
              >
                Nuova richiesta
              </Button>
            </ProtectedAction>
          </Stack>

          <RichiesteDocumentoNonEvaseTable
            richieste={richiesteNonEvase}
            onCambiaStato={handleCambiaStatoRichiesta}
            onCreaDocumento={handleCreaDocumentoDaRichiesta}
            onDownload={handleDownload}
          />

        </CardContent>
      </Card>
      {/* DOCUMENTI */}
      <Card sx={{ mb: 3, borderRadius: 3 }}>
        <CardContent>

          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Description color="primary" />
              <Typography variant="h6">Documenti Fascicolo</Typography>
            </Stack>
          </Stack>
          <DocumentoFascicoloTable
            key={refreshDocumentiKey}
            documenti={documenti}
            contribuenteId={contribuente?.id}
            fascicoloId={fascicoloId}
            onDownload={handleDownload}
            onDelete={handleDelete}
            onParse={handleParseDocumento}
            onHandleSort={handleSort}
          />

        </CardContent>
      </Card>

      {/* JOB LOGS */}
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>

          <Stack direction="row" spacing={1} alignItems="center" mb={2}>
            <WarningAmber color="warning" />
            <Typography variant="h6">
              Elaborazioni con anomalie
            </Typography>
          </Stack>

          {jobLogs.map((job, jobIndex) => {
            const docs = Object.entries(JSON.parse(job.testoplain))
              .map(([docKey, docStr]) => [docKey, JSON.parse(docStr)]);

            return (
              <Paper key={jobIndex} sx={{ p: 3, mb: 3, borderRadius: 2 }}>

                <Typography variant="subtitle2" sx={{ mb: 2 }}>
                  Job del {formatDate(job.dataInizio)}
                </Typography>

                <Stepper orientation="vertical" activeStep={-1}>
                {docs.map(([docKey, doc]) => {
                  const docState = jobDocsState[jobIndex]?.[docKey];

                  if (!docState) return null;

                  return (
                    <Step key={docKey} expanded>
                      <StepLabel>
                        Documento {doc.numeroDocumento}
                      </StepLabel>

                      <Typography color="error">
                        <WarningAmber /> Anomalie: {docState.anomalie?.join(", ")}
                      </Typography>

                      <Box sx={{ ml: 3, mt: 2 }}>
                        {docState.documento.scadenze.map((s, index) => (
                          <Box key={index} sx={{ mb: 2 }}>
                            <Typography variant="body2">Rata {s.numerorata}</Typography>

                            <TextField
                              fullWidth
                              label="Data scadenza"
                              type="date"
                              value={s.dataScadenza || ''}
                              onChange={(e) =>
                                handleChangeScadenza(jobIndex, docKey, index, 'dataScadenza', e.target.value)
                              }
                              InputLabelProps={{ shrink: true }}
                              sx={{ mt: 1, mb: 1 }}
                            />

                               <TextField
                                  fullWidth
                                  label="Importo"
                                  type="number"
                                  value={s.importo || ''}
                                  onChange={(e) => handleChangeScadenza(jobIndex, docKey,index, 'importo', e.target.value)}
                                  inputProps={{ inputMode: "decimal", step: "0.01" }}
                                  InputProps={{
                                    startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                  }}
                                  sx={{ mb: 1 }}
                                />

                                <TextField
                                  fullWidth
                                  label="Codice pagamento"
                                  value={s.codiceModuloPagamento || ''}
                                  onChange={(e) => handleChangeScadenza(jobIndex, docKey,index, 'codiceModuloPagamento', e.target.value)}
                                />

                                <TextField
                                  fullWidth
                                  label="QR code"
                                  value={s.qrcode || ''}
                                  onChange={(e) => handleChangeScadenza(jobIndex, docKey,index, 'qrcode', e.target.value)}
                                />
                          </Box>
                        ))}

                        <Button
                          variant="contained"
                          color="success"
                          sx={{ mt: 2 }}
                          onClick={() => handleConfirmSave(job.id, docKey, docState.documento)}
                        >
                          Conferma e Salva
                        </Button>
                      </Box>
                    </Step>
                  );
                })}

                </Stepper>

              </Paper>
            );
          })}

        </CardContent>
      </Card>

      {/* CHAT */}
      {fascicoloId && contribuente.studio && user.chatisactive === true && (
        <Box mt={3}>
          <FascicoloChat fascicoloId={fascicoloId} />
        </Box>
      )}

    </Container>
  );
}
